
import { Link } from "react-router-dom";


function BoardGovernors() {

  return (
     <main id="main">

  <div className="page-header">
    <svg viewBox="0 0 100 100" className="page-header__seal" aria-hidden="true" style={{color:'#fff'}}>
      <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="0.8"/>
      <path id="sealTopB" d="M 14,50 A 36,36 0 1,1 86,50" fill="none"/>
      <text fontSize="5.4" letterSpacing="1.5" fill="currentColor"><textPath  startOffset="50%" textAnchor="middle">JUSTICE FOR ALL</textPath></text>
    </svg>
    <div className="container">
      <div className="breadcrumb"><Link to="/">Home</Link> / Board of Governors</div>
      <h1>Board of Governors</h1>
      <p>The general direction and administration of the Legal Aid and Justice Authority are vested in a Board of Governors, constituted in accordance with the Legal Aid and Justice Authority Act.</p>
    </div>
  </div>

  <section className="section">
    <div className="container">

      <div className="grid-3">
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/azam-nazeer-tarrar.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Senator Azam Nazeer Tarar</h2>
            <h3>Federal Minister for Law and Justice</h3>
            <p>Chairperson</p>
            {/* <Link to=""  className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
         <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/naeem-akbar.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Raja Naeem Akbar</h2>
            <h3>Secretary, Ministry of Law and Justice</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/dg-laja.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Adil Anwar</h2>
            <h3>Director General, LAJA</h3>
            <p>Member / Secretary</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/mansoor-awan.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Mansoor Usman Awan</h2>
            <h3>Attorney-General for Pakistan</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/hamid-khan.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Senator Hamid Khan</h2>
            <h3>Member of the National Assembly</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/mahjabeen-abbasi.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Mah Jabeen Khan Abbasi</h2>
            <h3>Member of the National Assembly</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
         <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/imad.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Imdad Ullah Bosal</h2>
            <h3>Secretary, Finance</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/shiekh-khalique.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Abdul Khalique Shaikh</h2>
            <h3>Secretary, Ministry of Human Rights</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/pir-masood-chishti.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Pir M. Masood Chishti</h2>
            <h3>Vice-Chairman, Pakistan Bar Council</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/an.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Ayaz Shaukat</h2>
            <h3>Advocate General of ICT</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/jawad.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Jawad Dero</h2>
            <h3>Advocate General of Sindh</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/adnan.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Adnan Basharat</h2>
            <h3>Advocate General of Balochistan</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/amjad.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Amjad Pervaiz</h2>
            <h3>Advocate General of Punjab</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/shah-faisal.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Shah Faisal Utmankhel</h2>
            <h3>Advocate General of Khyber Pakhtunkhwa</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
        <article className="news-card">
          <div className="news-card__bog"><img src="/images/bog/haya-iman.jpg" alt="img"/></div>
          <div className="news-card__detail">
            <h2>Barrister Haya Emaan Zahid</h2>
            <h3>CEO, Legal Aid Society</h3>
            <p>Member</p>
            {/* <Link to="" className="read-more">More detail &rarr;</Link> */}
          </div>
        </article>
      </div>

    </div>
  </section>

</main>
  );
}

export default BoardGovernors;
